module.exports = __webpack_public_path__ + "assets/chart4.2.png?09fc06909784d1c95d994e8aecb325aa";